import { Component, OnInit, NgZone, EventEmitter, Renderer2, ChangeDetectionStrategy } from '@angular/core';
import { OrganisationService } from 'src/app/organisation/organisation.service';
import { Organisation } from 'src/app/generated/services/organisations/organisation';
import { Router, ActivatedRoute } from '@angular/router';
import { PgTitleComponent } from '../../shared/components/title-bar/title-bar.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { AgGridModule } from 'ag-grid-angular';
import { GridOptions, GridReadyEvent } from 'ag-grid-community';
import { AgGridService } from 'src/app/shared/ag-grid/ag-grid.service';
import { OrganisationToolbarComponent } from '../organisation-toolbar/organisation-toolbar/organisation-toolbar.component';

@Component({
  selector: 'app-organisations-list',
  templateUrl: './organisations-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SharedModule, AgGridModule]
})
export class OrganisationsListComponent implements OnInit, PgTitleComponent {
  title = new EventEmitter<string>();
  organisations: Organisation[] = [];
  temporarlyList: Organisation[] = [];

  parentOrganisation = '';

  toolbarComponentType = OrganisationToolbarComponent;
  toolbarComponent: any;

  gridOptions: GridOptions = {};

  constructor(private _organisationService: OrganisationService,
    private _router: Router,
    private _zone: NgZone,
    private _activatedRoute: ActivatedRoute,
    private _renderer: Renderer2) {
    // window.OrganisationsListComponent = { component: this, zone: this._zone };
  }

  columnDefs = [
    {
      headerName: 'نام فارسی', field: 'nameTranslations',
      valueGetter: (params: any) => params.data.nameTranslations['fa'] || '',
      filterValueGetter: (params: any) => params.data.nameTranslations['fa'] || ''
    },
    {
      headerName: 'نام انگلیسی',
      valueGetter: (params: any) => params.data.nameTranslations['en'] || '',
      filterValueGetter: (params: any) => params.data.nameTranslations['en'] || ''
    },
    {
      headerName: 'آدرس',
      field: 'address',
    },
    {
      headerName: 'Timezone',
      field: 'timezone',
    },
    {
      headerName: 'Actions',
      field: 'actions',
      cellRenderer: (params: any) => {
        const container = document.createElement('div');
        container.style.display = 'flex';
        container.style.gap = '5px';

        container.appendChild(
          AgGridService.iconButton(
            this._renderer,
            this._router,
            (_router, data) => this.edit(data, _router),
            params.data,
            'fa-pencil'
          )
        );

        container.appendChild(
          AgGridService.iconButton(
            this._renderer,
            this._router,
            (_router, data) => this.add(data, _router),
            params.data,
            'fa-plus'
          )
        );

        container.appendChild(
          AgGridService.iconButton(
            this._renderer,
            this._router,
            (router, data) => this.organisationFilter(data, router),
            params.data,
            'fa-code-branch'
          )
        );
        return container;
      }
    }
  ];

  ngOnInit() {
    this.title.emit('Organisations');
    this.gridOptions = AgGridService.getOptions();
    this._activatedRoute.paramMap.subscribe(p => {
      this._organisationService.get().subscribe(organisations => {
        this.organisations = organisations;
        const organisationId = p.get('parentOrganisationId');
        this.temporarlyList = (organisationId) ?
          organisations.filter(organisation => organisation.parentOrganisation === organisationId) :
          organisations.filter(organisation => organisation.parentOrganisation === '');

      });
    });
  }

  gridSetting(event: GridReadyEvent) {
    AgGridService.setting(event);
  }

  addRecord() {
    this._router.navigate(['/organisations/new/root']).then(_ => _);
  }

  organisationFilter(organisation: Organisation, router: Router) {
    router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      router
        .navigate(['organisations/list/', organisation.name])
        .then((e) => console.log(`Result of Navigation is ${e}`));
    });
  }

  edit(organisation: Organisation, router: Router) {
    router.navigate(['organisations', 'edit', organisation.name]).then();
  }

  add(organisation: Organisation, router: Router) {
    router.navigate(['organisations', 'new', organisation.name]).then();
  }
}
